import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import events from '@/hooks/events';
import actions from '../constants';

const useUpdateActiveThemeProperties = () => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({ type: actions.UPDATE_ACTIVE_THEME_PROPERTIES, properties }), []);
};

const useUpdateThemeEnabled = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ name }) => handler({
    type: actions.UPDATE_THEME_ENABLED, category, code, name,
  }), [category, code]);
};

const useChooseTheme = () => {
  const handler = useDispatch();
  return useCallback(({ code, name }) => handler({ type: actions.CHOOSE_THEME, code, name }), []);
};

const useUpdateThemesFilter = (category) => {
  const handler = useDispatch();
  return useCallback(({ value }) => handler({ type: actions.UPDATE_THEMES_FILTER, category, value }), [category]);
};

const useToggleThemesPresentation = (category) => {
  const handler = useDispatch();
  return useCallback(({ display }) => handler({
    type: actions.TOGGLE_THEMES_PRESENTATION, category, display,
  }), [category]);
};

export default {
  useChooseTheme,
  useHideSaveTheme: () => events.useSimpleDispatch(actions.HIDE_SAVE_THEME),
  useRefreshThemes: (category) => events.useRefreshByCategory(actions.REFRESH_THEMES, category),
  useFetchThemes: (category) => events.useFetchByCategory(actions.FETCH_THEMES, category),
  useToggleThemesPresentation,
  useShowSaveTheme: (category, { code }) => events.useDispatchByCode(actions.SHOW_SAVE_THEME, category, code),
  useUpdateActiveThemeProperties,
  useUpdateTheme: () => events.useSimpleDispatch(actions.UPDATE_THEME),
  useUpdateThemeEnabled,
  useUpdateThemesFilter,
};
